import { ACTION_TYPE } from './useRegenerateSecret';

const initialState = {
  data: {},
  loading: false,
  error: false,
};

export const reducerRegenerateSecret = {
  [ACTION_TYPE]: (state = initialState, action) => {
    switch (action.type) {
      case `${ACTION_TYPE}_CALLED`:
        return {
          ...state,
          loading: true,
          error: false,
        };

      case `${ACTION_TYPE}_STAGE_COMPLETED`:
        return {
          ...state,
          data: {
            ...state.data,
            stage: action.payload,
            alertData: [],
          },
          loading: false,
          error: false,
        };

      case `${ACTION_TYPE}_PROD_COMPLETED`:
        return {
          ...state,
          data: {
            ...state.data,
            prod: action.payload,
            alertData: [],
          },
          loading: false,
          error: false,
        };
      case `${ACTION_TYPE}_SECERT_REG_ERROR`:
        return {
          ...state,
          data: {
            ...state.data,
            alertData: action.payload,
          },
          loading: false,
          error: false,
        };

      case `${ACTION_TYPE}_ERROR`:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      case `${ACTION_TYPE}_RESET`:
        return {
          ...state,
          initialState,
        };
      case `${ACTION_TYPE}_ALERT_DATA_RESET`:
        return {
          ...state,
          data: {
            ...state.data,
            alertData: [],
          },
        };
      default:
        return state;
    }
  },
};
